import { useContext, useState } from "react";
import { AppContext } from "../../Context";
import { FilterButton } from "../hooks/filtres/useTableFilters";
import { Preloader } from "../Preloader";

const OrcamentoList = () => {
  const {
    dto,
    dtoLength,
    editMode,
    cancelEdit,
    updateDto,
    deleteDto,
    lookup,
    getItemlookup,
    getPreloader,
    filterdto,
    setFilterdto,
  } = useContext(AppContext);

  // Storing users new data when they editing their info.
  const [newData, setNewData] = useState({});
  const [fqtde, setFqtde] = useState();
  const [fpreco, setFpreco] = useState();
  const [ftotal, setFtotal] = useState();

  const saveBtn = () => {
    updateDto(newData);
  };

  const updateTotal = (e) => {
    if (e.target.name === "_quantidade")
        setFqtde(e.target.value);
    if (e.target.name === "_precounitario")
        setFpreco(e.target.value);  
    if (fqtde * fpreco > 0)
        setFtotal((fqtde * fpreco).toFixed(2));
  };

  const updateNewData = (e, field) => {
    if (e !== null) {
        let tarefa = getItemlookup(newData.idorcamento); 
        
        let aceito = newData.aceito;        
        if (field === "aceito")
            aceito = (aceito === "0" ? "1" : "0");            

        updateTotal(e);
        setNewData({
            ...newData,
            [field]: e.target.value,
            tarefa: tarefa,
            total: ftotal,
            aceito: aceito,
        });
    } 
  };
  
  const enableEdit = (idorcamento,fornecedor,contato,quantidade,precounitario,total,aceito,idtarefa,tarefa,mensagem) => {
    setNewData({idorcamento,fornecedor,contato,quantidade,precounitario,total,aceito,idtarefa,tarefa,mensagem});
    editMode(idorcamento);

    setFqtde(quantidade);
    setFpreco(precounitario);
    setFtotal(total);
  };

  const deleteConfirm = (idorcamento) => {
    if (window.confirm("Confirma a exclusão?")) {
      deleteDto(idorcamento);
    }
  };

  return !dtoLength ? (      
    <p>{dtoLength === null ?
        <Preloader/> : "Favor, insira um orçamento"}</p>
  ) : 
  (<><FilterButton/>
    <table className="highlight">
      <thead>
        <tr>
          <th>Tarefa e responsável</th>
          <th>Fornecedor</th>
          <th>Contato</th>
          <th>Total</th>
          <th>Ação</th>
        </tr>
      </thead>
      <tbody>
        {dto.filter((data) => {
          return filterdto === undefined || (String)(data.fornecedor).toUpperCase().includes((String)(filterdto).toUpperCase()) || (String)(data.contato).toUpperCase().includes((String)(filterdto).toUpperCase()) || (String)(data.tarefa).toUpperCase().includes((String)(filterdto).toUpperCase()) 
            || (((String)(filterdto).toLowerCase() === "aceito" || (String)(filterdto).toLowerCase() === "aprovado") && data.aceito === "1") 
            || (((String)(filterdto).toLowerCase().includes("aceito") || (String)(filterdto).toLowerCase().includes("aprovado")) && (String)(filterdto).toLowerCase().includes("não") && data.aceito === "0")? data : null
        })
        .map(({idorcamento,fornecedor,contato,quantidade,precounitario,total,aceito,idtarefa,tarefa,mensagem, isEditing }) => {
          return isEditing === true ? (
            <tr key={idorcamento}>
              <td colSpan={4}>
                <div className="row">
                    <div className="input-field col s6">
                    <span className="labelfake">Tarefa e Responsável</span>
                        <select id="_tarefa" className="browser-default"
                            onChange={(e) => updateNewData(e, "idtarefa")}
                            required
                            defaultValue={idtarefa}>
                        <option key={-1} value="0" disabled selected>Selecione uma tarefa</option>
                            {lookup.map((lkp) => {
                                return <option key={lkp.idtarefa} value={lkp.idtarefa}>{lkp.nome}</option>
                            })}
                        </select> 
                    </div>
                    <div className="input-field col s6">
                    <span className="labelfake">Fornecedor</span>
                        <input
                            type="text"
                            name="_fornecedor"
                            className="validate"
                            defaultValue={fornecedor}
                            onChange={(e) => updateNewData(e, "fornecedor")}/>
                    </div>
                </div>

                <div className="row">
                    <div className="input-field col s12">
                    <span className="labelfake">Contato</span>
                        <input
                            type="text"
                            name="_contato"
                            className="validate"
                            defaultValue={contato}
                            onChange={(e) => updateNewData(e, "contato")}/>
                    </div>
                </div>
                <div className="row">
                    <div className="input-field col s2">
                        <span className="labelfake">Quantidade</span>
                        <input
                            type="number"
                            name="_quantidade"
                            defaultValue={quantidade}
                            onBlur={(e) => updateTotal(e)}
                            onChange={(e) => updateNewData(e, "quantidade")}/>
                    </div>
                    <div className="input-field col s1"><br/>x</div>
                    <div className="input-field col s2">
                        <span className="labelfake">Preço Unitario</span>
                        <input
                            type="number"
                            name="_precounitario"
                            defaultValue={precounitario}
                            onBlur={(e) => updateTotal(e)}
                            onChange={(e) => updateNewData(e, "precounitario")}/>
                    </div>
                    <div className="input-field col s1"><br/>=</div>
                    <div className="input-field col s3">
                        <span className="labelfake">Total</span>
                        <input
                            type="number"
                            name="_total"
                            value={ftotal} 
                            onChange={(e) => updateNewData(e, "total")}/>
                    </div>
                    <div className="input-field col s3">
                        <span className="labelfake">Proposta aceita</span>
                        <div className="switch">
                            <label>
                                Não
                                <input
                                    type="checkbox"
                                    name="_aceito"
                                    defaultChecked={aceito==="1"?true:false} 
                                    onClick={(e) => updateNewData(e, "aceito")}/>
                                <span className="lever"></span>
                                Aceito
                            </label>
                        </div>
                    </div>
                </div>

              </td>
              <td>
                <a className="waves-effect waves-light btn green-btn" onClick={() => saveBtn()}>
                <i className="material-icons left">save</i>
                </a>
                <a
                  className="waves-effect waves-light btn default-btn"
                  onClick={() => cancelEdit(idorcamento)}
                >
                <i className="material-icons left">cancel</i>
                </a>
              </td>
            </tr>
          ) : (
            <tr key={idorcamento}>
                <td className={(aceito === "1"?"green-information":"")}>{tarefa}</td>
                <td className={(aceito === "1"?"green-information":"")}>{fornecedor}</td>
                <td className={(aceito === "1"?"green-information":"")}>{contato}</td>
                <td className={(aceito === "1"?"green-information":"")}>R$ {(total==="0,00"?" - " : total)}</td>
                <td>
                        <a
                        className="waves-effect waves-light btn default-btn"
                        onClick={() => enableEdit(idorcamento,fornecedor,contato,quantidade,precounitario,total,aceito,idtarefa,tarefa)}
                        >
                        <i className="material-icons left">edit</i>
                        </a>
                        <a
                        className="waves-effect waves-light btn red-btn"
                        onClick={() => deleteConfirm(idorcamento)}
                        >
                        <i className="material-icons left">delete</i>
                        </a>
                </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </>);
};

export default OrcamentoList;